import { render, staticRenderFns } from "./NomeColaborador.vue?vue&type=template&id=b61335cc&"
import script from "./NomeColaborador.vue?vue&type=script&lang=js&"
export * from "./NomeColaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports